export const colors = {
  PRIMARY_COLOR: '#3A57E8',
}
